import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';

import { FormLabelWrapper, TextInput } from '@restworld/ui-ds-base';
import { TermsAndConditions } from '../../../legacy';

import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';
import { useBasicProfileInformation } from '../../worker-application-wizard.constants';
import { WizardStepProps } from '../../worker-application-wizard.types';
import { HelperTextRElement } from '../form-inputs';
import { PhoneNumberField } from './wizard-third-step';
import { AlreadyUsedLoginHelperText } from './already-used-login-helper-text';

export const WizardInitialStep: React.FunctionComponent<WizardStepProps> = () => {
  const { errorsTextMap, conflictFields } = useWorkerApplicationCxt();
  const { control } = useFormContext();
  const router = useRouter();
  const basicProfileInformation = useBasicProfileInformation();
  return (
    <div className="flex flex-col gap-4">
      {basicProfileInformation?.map(({ key, rules, title, type, placeholder }, i) => {
        const helperText: string = errorsTextMap[key];
        let customHelperText = <HelperTextRElement helperText={helperText} />;
        // Only a field the backend named as already taken gets the "log in instead" way out.
        // This used to fire on any field once a conflict had been seen, which is how a phone
        // conflict came out as "e-mail already used" on the e-mail input.
        if (key === 'email' && conflictFields.includes(key) && helperText) {
          customHelperText = <AlreadyUsedLoginHelperText key={`${key}-helper-text-${i}`} field="email" />;
        }
        if (key === 'phone_number') return <PhoneNumberField key={`${key}-phone-number-${i}`} />;
        return (
          <FormLabelWrapper key={key + i} id={key} label={title}>
            <Controller
              name={key}
              control={control}
              rules={rules}
              render={({ field }) => (
                <TextInput
                  id={key}
                  placeholder={placeholder}
                  type={type}
                  helperText={customHelperText}
                  color={helperText ? 'failure' : undefined}
                  data-cy={`${key}-input`}
                  key={`${key}-input-${i}`}
                  {...field}
                />
              )}
            />
          </FormLabelWrapper>
        );
      })}
      {!router.query.id && (
        <div className="pt-4">
          <Controller
            name="tAndC"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TermsAndConditions
                isChecked={field.value}
                onCheckboxChange={(e) => field.onChange(e.target.checked)}
                iserror={errorsTextMap['tAndC']}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
export default WizardInitialStep;
